import styled, { css } from 'styled-components'

export interface IGetScollerCSS {
  border?: string
  bgColor?: string
}

export const getScollerCSS = ({ border, bgColor = 'rgba(0, 0, 0, 0.5)' }: IGetScollerCSS = {}) => css`
  overflow: auto;

  &::-webkit-scrollbar {
    -webkit-appearance: none;
    width: ${({ theme }) => theme.layout.xxs};
    border: ${({ theme }) => border || `1px solid ${theme.palette.blueGray60}`};
    border-radius: ${({ theme }) => theme.space.xs};
  }

  &::-webkit-scrollbar-thumb {
    width: ${({ theme }) => theme.layout.xxs};
    height: ${({ theme }) => theme.layout.sm};
    border-radius: ${({ theme }) => theme.space.xs};
    background-color: ${bgColor};
    -webkit-box-shadow: 0 0 1px rgba(255, 255, 255, 0.5);
  }
`

export const Wrapper = styled.div`
  ${getScollerCSS()}
`
